export enum BookmarkTypes {
  GIG = 1,
  JOB = 2,
  VACANCY = 3,
}
